import { CatalogTokens } from './catalog-tokens'

export function CatalogTokensTab() {
  return <CatalogTokens />
}
